import { Component, OnInit, Inject, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/shared/dialog.component';
import { Assessment } from 'src/app/models/AssessmentModel';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'cw-ci-assessment-list',
  templateUrl: './assessment-type-list.component.html',
  styleUrls: ['./assessment-type-list.component.scss'],
})

export class AssessmentTypeListComponent implements OnInit {
  @ViewChild(DialogComponent, { static: true }) cwdialog: DialogComponent;

  okButton = true;
  cancelButton = true;
  showCloseButton = true;
  dialogTitle:string;

  @Input()
  dialogMessage:string;

  continueButtonText = 'Continue';
  cancelButtonText = 'Cancel';
  planId: number;
  isInTrial: boolean;
  
  assessmentTypeForm = new FormGroup ({
      assessment: new FormControl('', [Validators.required]),
  })
  
  constructor(public _sessionService: SessionService, public dialogRef: MatDialogRef<AssessmentTypeListComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
    this.dialogTitle = 'Select assessment';
    this.dialogMessage = 'Which assessment would you like to begin?'
    this.planId = this.data.planId;
    this.isInTrial = this.data.isInTrial;
    if (this.dialogRef.disableClose) {
      this.showCloseButton = false;
      this.cancelButton = false;
    }
  }

   buttonAction(value?: any): void {
    const action = (value != "cancel") ? this.assessmentTypeForm.value.assessment: undefined;
    this.dialogRef.close(action);
  }
}